import { $translate } from '@/utils/i18n';
export default {
    configuration: true,
    searchList: {
        searchTxt: [],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        selectBtn: false,
        clickState: true,
        leftOperation: false,
        height: 400,
        columns: [
            {
                label: $translate('lang.E3202103220015', { defaultText: '企业名称' }),
                align: 'center',
                prop: 'enterpriseName',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202103220001', { defaultText: '企业前缀' }),
                align: 'center',
                prop: 'prefixCode',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202102220013', { defaultText: '产品编码' }),
                align: 'center',
                prop: 'productCode',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202101260018', { defaultText: '产品名称' }),
                align: 'center',
                prop: 'productName',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202103080001', { defaultText: '标识编码' }),
                align: 'center',
                prop: 'identityCode',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202103160013', { defaultText: '注册时间' }),
                align: 'center',
                prop: 'createDate',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202103230002', { defaultText: '注册来源' }),
                align: 'center',
                prop: 'dataSource',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: $translate('lang.E3202103230001', { defaultText: '操作用户' }),
                align: 'center',
                prop: 'operator',
                filter: true,
                require: true,
                width: 100
            }
        ]
    },
    page: {
        layout: 'total, sizes',
        pageSize: 200,
        pageNo: 1,
        pageSizes: [200]
    },
    showPage: false
};
